import {isBefore, parse, startOfMinute} from "date-fns";

export const SCHEDULE_TYPE_OPTIONS = [
    {value: "VISIT", label: "Visita"},
    {value: "PATROL", label: "Ronda"},
];

export const scheduleTypeLabel = (type) => SCHEDULE_TYPE_OPTIONS.find(option => option.value === type)?.label ?? "";

export const SCHEDULE_STATUS_META = {
    OPEN: {label: "Em aberto", color: "#586073", background: "#eef0f4", dot: "#8b94a4"},
    CANCELED: {label: "Cancelado", color: "#b21f33", background: "#fbe9ec", dot: "#d23b4e"},
    EXECUTED: {label: "Realizado", color: "#0e6b3c", background: "#dff2e6", dot: "#1f9d57"},
};

export const matchesType = (address, type) =>
    type === "VISIT" ? !!address.visitable : type === "PATROL" ? !!address.patrollable : false;

export const matchingAddresses = (citizen, type) =>
    (citizen.addresses ?? []).filter(address => matchesType(address, type));

export const composeAddress = ({address, number, complement, neighborhood, city} = {}) => {
    const main = [address, number].filter(Boolean).join(", ");
    const tail = [complement, neighborhood, city].filter(Boolean).join(" - ");
    return [main, tail].filter(Boolean).join(" - ");
};

export const hasWindowMismatch = (address, schedule) => {
    const {availabilityStartTime: addressStart, availabilityEndTime: addressEnd} = address;

    if (!addressStart || !addressEnd) return false;

    const overlaps = addressStart < schedule.endTime && schedule.startTime < addressEnd;

    return !overlaps;
};

export const isRetroactive = ({date, startTime}) =>
    isBefore(parse(`${date} ${startTime}`, "dd/MM/yyyy HH:mm", new Date()), startOfMinute(new Date()));

export const conflictInfo = (citizen, type, schedule, selectedIds = [], confirmed = false) => {
    const matches = matchingAddresses(citizen, type);
    const noEligibleAddress = matches.length === 0;
    const needsChoice = matches.length > 1 && selectedIds.length === 0;
    const selectedAddresses = matches.filter(address => selectedIds.includes(address.id));
    const mismatch = selectedAddresses.some(address => hasWindowMismatch(address, schedule)) && !confirmed;

    return {
        matches,
        selectedAddresses,
        noEligibleAddress,
        needsChoice,
        mismatch,
        hasConflict: noEligibleAddress || needsChoice || mismatch,
    };
};

export const translateScheduledVisitError = (code, defaultMessage) => {
    const messages = {
        "scheduled.visit.citizen.not.found": "Protegido não encontrado ou sem permissão de acesso.",
        "scheduled.visit.not.found": "Agendamento não encontrado.",
        "scheduled.visit.invalid.window.format": "Formato de data/hora inválido.",
        "scheduled.visit.invalid.window": "O horário final deve ser posterior ao inicial.",
        "scheduled.visit.invalid.execution.dt.format": "Formato da data de execução inválido.",
        "scheduled.visit.already.executed": "Este agendamento já foi concluído e não pode ser alterado.",
        "scheduled.visit.already.canceled": "O agendamento já foi encerrado.",
    };

    return messages[code] ?? defaultMessage;
};
